import { isAxiosError as r } from "axios";
import { ErrorCode as s } from "@ancon/wildcat-types";
function t(o, i) {
  const e = o;
  return i != null ? t(o) && o.code === i : r(e) || !(e != null && e.code) ? !1 : Object.values(s).includes(e.code);
}
export {
  t as default
};
